import React from 'react';
import PropTypes from 'prop-types';
import NavActions from '../../actions';

export default class LocaleIcon extends React.PureComponent {
    static propTypes = {
        isActive: PropTypes.bool,
        currentLocale: PropTypes.string
    };

    static contextTypes = {
        messages: PropTypes.object,
        isMobile: PropTypes.bool
    };

    showLocale = () => {
        if (!this.props.isActive) {
            NavActions.mobileLocaleActive(true);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.mobileLocaleActive(false);
            if (this.context.isMobile) {
                NavActions.mobileNavActiveLinks(true);
            }
        }

        //Reset all other clickable items
        NavActions.tabletNavActive(false);
        NavActions.mobileActiveLinkIndex(null);
        NavActions.searchActive(false);
        NavActions.mobileUserActive(false);
    };

    render() {
        const localeOnClick = this.context.isMobile ? this.showLocale : null;

        return (
            <a
                role="menuitem"
                tabIndex="0"
                data-locale={this.props.currentLocale}
                title={this.props.currentLocale}
                onClick={localeOnClick}
                className="locale-icon text-color-hover">
                {!this.context.isMobile || (this.context.isMobile && !this.props.isActive) ? <i className="eg-header-icon-locale" /> : ''}
            </a>
        );
    }
}
